import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { OrderDetailPage, orderQueryOptions } from '@/features/orders';

export const Route = createFileRoute('/_authed/_active/s/$storeId/orders/$orderId')({
  staticData: {
    tours: [
      'orders.detail',
      'orders.detail-actions',
      'production.card',
      'production.stage-actions',
    ],
  },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params }) => {
    const order = await context.queryClient.query({
      ...orderQueryOptions(params.storeId, params.orderId),
      staleTime: 'static',
    });
    return { crumb: order.name };
  },
  component: OrderDetailPage,
});
